import React from 'react';
import { useAuth } from '../../context/AuthContext';
import AppBrandMark from '../AppBrandMark';
import ChangePasswordForm from './ChangePasswordForm';
import './ChangePassword.css';

/**
 * Full-screen gate shown after sign-in while users/{uid}.mustChangePassword is
 * true (new account or admin/temp password reset). Blocks the rest of the app
 * until the user picks their own password.
 */
export default function ForcePasswordChangeScreen() {
  const { profile, signOut, refreshProfile } = useAuth();

  return (
    <div className="cp-screen">
      <div className="cp-card">
        <h1 className="cp-brand"><AppBrandMark size="login" /></h1>
        <h2 className="cp-title">Choose your password</h2>
        <p className="cp-desc">
          Hi {profile?.firstName || profile?.displayName || 'there'} — you signed in with a temporary
          password. Set your own password to continue.
        </p>
        <ChangePasswordForm
          currentPasswordLabel="Temporary (current) password"
          submitLabel="Set password and continue"
          onSuccess={refreshProfile}
        />
        <button type="button" className="cp-signout" onClick={signOut}>
          Sign out
        </button>
      </div>
    </div>
  );
}
